import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SeparatorText, SeparatorWrapper } from './styled';
const Separator = ({ children }) => (_jsx(SeparatorWrapper, { children: _jsx(SeparatorText, { children: children }) }));
export default Separator;
